import React from 'react';
import ReactDOM from 'react-dom';
import { Button, Modal } from 'react-bootstrap';

type ReticleSaveModalProps = {
  show: boolean;
  onSaveToCurrentSite: () => void;
  onSaveToSelectedSites: () => void;
  onSaveToAllSites: () => void;
  onCancel: () => void;
  hasSelectedSites: boolean;
};

const ReticleSaveModal: React.FC<ReticleSaveModalProps> = ({
  show,
  onSaveToCurrentSite,
  onSaveToSelectedSites,
  onSaveToAllSites,
  onCancel,
  hasSelectedSites,
}) => {
  if (!show) return null;

  const modalContent = (
    <Modal
      show={show}
      onHide={onCancel}
      backdrop="static"
      centered
      dialogClassName="reticle-save-modal"
      style={{ zIndex: 99999 }}
    >
      <Modal.Header closeButton>
        <Modal.Title>Save Changes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>How would you like to apply the changes?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onSaveToCurrentSite}>
          Save
        </Button>
        {hasSelectedSites && (
          <Button variant="info" onClick={onSaveToSelectedSites}>
            Save to Selected Sites
          </Button>
        )}
        <Button variant="success" onClick={onSaveToAllSites}>
          Save to All Sites
        </Button>
        <Button variant="secondary" onClick={onCancel}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );

  // Render modal using portal to document.body to ensure it's above everything
  return ReactDOM.createPortal(modalContent, document.body);
};

export default ReticleSaveModal;

